import axiosApiClient from '..';
import { handleError, throwErrorIfWrongStatus } from './utils';

const BASE_URL = '/d/influencer-examples';

class InfluencerExampleService {
  fetchInfluencerExamples = async (page, search) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}?page=${page}&search=${search}`);
      throwErrorIfWrongStatus(response, 200);
      const { data, total, perPage: perPageResponse } = response.data.data;
      return { data, maxReached: total <= +page * +perPageResponse, page };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching influencer examples.');
    }
  };

  revertInfluencerExample = async influencerExampleId => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/revert/${influencerExampleId}`);
      throwErrorIfWrongStatus(response, 200);
      const { influencerExample } = response.data.data;
      return { influencerExample };
    } catch (err) {
      throw handleError(err, 'Error occurred while reverting influencer example.');
    }
  };

  editInfluencerExample = async (influencerExampleId, text) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/${influencerExampleId}`, { text });
      throwErrorIfWrongStatus(response, 200);
      const { influencerExample } = response.data.data;
      return { influencerExample };
    } catch (err) {
      throw handleError(err, 'Error occurred while editing influencer example.');
    }
  };
}

export default new InfluencerExampleService();
